import { render, staticRenderFns } from "./GPS.vue?vue&type=template&id=74296260&"
import script from "./GPS.vue?vue&type=script&lang=ts&"
export * from "./GPS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('74296260', component.options)
    } else {
      api.reload('74296260', component.options)
    }
    module.hot.accept("./GPS.vue?vue&type=template&id=74296260&", function () {
      api.rerender('74296260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/GPS.vue"
export default component.exports